<div class="container">
  <div class="close" (click)="dialogRef.close(this.uploadSuccess)">
    <img src="assets/icons/news/close.svg" alt="close" />
  </div>
  <h3 [class.error]="data.options[1] && data.options[1] === 'error'">{{ data['title'] }}</h3>

  <p>
    {{ data.body }}
  </p>

  <div class="passport-picture">
    <img *ngIf="imageShown" src="{{ imageShown }}" alt="" />
    <div *ngIf="!imageShown" class="upload-icon-container" (click)="triggerUploadImage()">
      <img src="assets/icons/upload-file.svg" alt="upload-icon" />
    </div>
    <div class="image-uploader">
      <label for="image-upload">Elegir foto o PDF</label>
      <input
        #fileUploadInput
        id="image-upload"
        type="file"
        value=""
        accept="image/*, application/pdf"
        (change)="readImage($event)"
      />
    </div>
    <label for="image" class="image-error" *ngIf="imageErrorMessage !== ''">{{
      imageErrorMessage
    }}</label>

    <ng-container *ngIf="!data.disableComment">
      <div class="mesagge">
        <div class="title">¿Querés agregar un mensaje?</div>
      </div>
      <mat-form-field appearance="outline" class="contentComment">
        <input
          matInput
          type="text"
          maxlength="200"
          [(ngModel)]="textComment"
          placeholder="Comentario"
        />
      </mat-form-field>
    </ng-container>
  </div>

  <button
    class="basic-btn"
    [disabled]="!passportImage"
    [class.error]="data.options[1] && data.options[1] === 'error'"
    (click)="uploadImage()"
  >
    {{ data.options[0] }}
  </button>

  <div class="loading-container" *ngIf="loading">
    <div class="circle-loader" [class.load-complete]="uploadSuccess">
      <div class="checkmark draw"></div>
    </div>
    <h3 [innerHTML]="loadingMessage"></h3>
  </div>
</div>
